<template>
  <div class="page" style="text-align: left; padding: 45px">
    <div class="row">
      <div style="width: 99%">
        <div class="header" id="header" style="width: 100%; height: 100px">
          <div style="width: 11%; float: left">
            <img
              src="../../assets/print_logo.jpg"
              style="width: 100px; height: 100px"
            />
          </div>
          <div style="width: 89%; float: right">
            <p
              style="
                font-size: 28px;
                font-family: Times New Roman;
                text-align: center;
                vertical-align: text-top;
              "
            >
              <b v-if="printModel.form.BaseInfoEditPrintTitleCheckbox==false">Draco Natural Products, Inc.</b>
              <b v-if="printModel.form.BaseInfoEditPrintTitleCheckbox">{{printModel.form.BaseInfoEditPrintTitle}}</b>
            </p>
            <p
              style="
                font-size: 28px;
                font-family: Times New Roman;
                text-align: center;
                vertical-align: text-top;
              "
            >
              <b><u>分析检测报告</u></b>
            </p>
          </div>
        </div>

        <!-- Product info -->
        <table style="width: 99%">
              <tbody>
                
          <tr v-show="printModel.form.productType">
            <td style="width: 25%"><b>产品类别</b></td>
            <td>
              {{ printModel.form.productType }}
            </td>
          </tr>
          <tr v-show="printModel.form.BaseInfoProductName">
            <td style="width: 25%"><b>产品名称</b></td>
            <td style="width: 75%" colspan="3">
              {{ printModel.form.BaseInfoProductName }}
            </td>
          </tr>
          <tr v-show="printModel.form.versionNumber">
            <td style="width: 25%"><b>版本号</b></td>
            <td style="width: 75%" colspan="3">
              {{ printModel.form.versionNumber }}
            </td>
          </tr>
          <tr v-show="printModel.form.BaseInfoLot">
            <td style="width: 25%"><b>批号</b></td>
            <td style="width: 75%" colspan="3">{{ printModel.form.BaseInfoLot }}</td>
          </tr>
          <tr>
            <td v-show="printModel.form.BaseInfoItemCode" style="width: 25%">
              <b>产品编号</b>
            </td>
            <td v-show="printModel.form.BaseInfoItemCode" style="width: 25%">
              {{ printModel.form.BaseInfoItemCode }}
            </td>
            <td
              v-show="printModel.form.BaseInfoCountryofOrigin"
              style="width: 25%"
            >
              <b>原产地</b>
            </td>
            <td
              v-show="printModel.form.BaseInfoCountryofOrigin"
              style="width: 25%"
            >
              {{ printModel.form.BaseInfoCountryofOrigin }}
            </td>
          </tr>
          <tr>
            <td v-show="printModel.form.BaseInfoManufacturingDate" style="width: 25%">
              <b>生产日期</b>
            </td>
            <td v-show="printModel.form.BaseInfoManufacturingDate" style="width: 25%">
              {{ formatTime(printModel.form.BaseInfoManufacturingDate,"yyyy-MM-dd") }}
            </td>
            <td v-show="printModel.form.BaseInfoExpirationDate" style="width: 25%">
              <b>有效期</b>
            </td>
            <td v-show="printModel.form.BaseInfoExpirationDate" style="width: 25%">
                  {{ formatTime(printModel.form.BaseInfoExpirationDate,"yyyy-MM-dd") }}
            </td>
          </tr>

              <!-- <tr v-show="printModel.form.BaseInfoCustomRowKey1">
                <td style="width: 25%"><b>{{ printModel.form.BaseInfoCustomRowKey1 }}</b></td>
                <td colspan="3">
                  {{
                    printModel.form.BaseInfoCustomRowValue1
                  }}
                </td>
              </tr>
              <tr v-show="printModel.form.BaseInfoCustomRowKey2">
                <td style="width: 25%"><b>{{ printModel.form.BaseInfoCustomRowKey2 }}</b></td>
                <td colspan="3">
                  {{
                    printModel.form.BaseInfoCustomRowValue2
                  }}
                </td>
              </tr> -->
              </tbody>
              <!-- <tbody
                v-for="(item, baseIndex) in printModel.baseCustomFieldAttr"
                :key="baseIndex+88"
              >
                <tr v-show="item.customKey">
                  <td style="width: 30%">
                    <b>{{ item.customKey }}</b>
                  </td>
                  <td colspan="3">
                    <span t-field="o.apperance">{{ item.customValue }}</span>
                  </td>
                </tr>
              </tbody> -->
        </table>
        
            <table style="width: 99%" v-show="printModel.baseInfoCustomFieldList && printModel.baseInfoCustomFieldList.length>0">
              <tr v-for="(baseinfoCustom,baseinfoIndex) in printModel.baseInfoCustomFieldList" :key="baseinfoIndex">
                <td style="width: 25%"><b>{{baseinfoCustom.baseInfoInput1}}</b></td>
                <td style="width: 75%">
                  {{ baseinfoCustom.baseInfoInput2 }}
                </td>
              </tr>
            </table>
        <!-- General Specification -->
        <div style="font-size: 18px">
          <b><u>标准规格</u></b>
        </div>

        <!-- 遍历table -->
        <template v-if="isSingle().count > 1">
          <table
            style="width: 98%;border-collapse: collapse;"
            cellspacing="0"
            class="tab"
          >
            <thead>
              <tr style="text-align: left;border-bottom:2px solid gray">
                <th v-show="printModel.commonNameArr.length > 0">通用名/其他名称</th>
                <th v-show="printModel.inclNameArr.length > 0">INCI名称</th>
                <th v-show="printModel.botanicalNameArr.length > 0">植物学名</th>
                <!-- <th v-show="printModel.nativeHerbsArr.length > 0">
                  Major Constituents in Native Herbs
                </th> -->
                <th v-show="printModel.partUsedArr.length > 0">使用部位</th>
                <th v-show="printModel.percentageArr.length > 0">百分比 </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="i" v-for="(tag, i) in maxArr">
                <td v-show="printModel.commonNameArr.length > 0">
                  <div v-show="i + 1 <= printModel.commonNameArr.length">{{
                    printModel.commonNameArr[i]
                  }}</div>
                </td>
                <td v-show="printModel.inclNameArr.length > 0">
                  <div v-show="i + 1 <= printModel.inclNameArr.length">{{
                    printModel.inclNameArr[i]
                  }}</div>
                </td>
                <td v-show="printModel.botanicalNameArr.length > 0">
                  <div
                    v-show="i + 1 <= printModel.botanicalNameArr.length"
                    >{{ printModel.botanicalNameArr[i] }}</div
                  >
                </td>
                <!-- <td v-show="printModel.nativeHerbsArr.length > 0">
                  <template
                    v-show="i + 1 <= printModel.nativeHerbsArr.length"
                    >{{ printModel.nativeHerbsArr[i] }}</template
                  >
                </td> -->
                <td v-show="printModel.partUsedArr.length > 0">
                  <div v-show="i + 1 <= printModel.partUsedArr.length">{{
                    printModel.partUsedArr[i]
                  }}</div>
                </td>
                <td v-show="printModel.percentageArr.length > 0">
                  <div v-show="i + 1 <= printModel.percentageArr.length">{{
                    printModel.percentageArr[i]
                  }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
        <div style="width: 100%" v-else-if="isSingle().count==1">
          <table style="width: 100%" cellspacing="0" class="tab">
            <tr>
              <td style="width: 25%">
                <b>{{isSingle().name}}</b>
              </td>
              <td style="width: 75%">
                <span  v-for="(item,val,index) in isSingle().arr" :key="index" >{{item}}<span v-if="val+1<isSingle().arr.length">, </span></span>
              </td>
            </tr>
          </table>
        </div>
        
        <template v-if="isShowTable">
          <table
            style="width: 98%;margin-top:10px;"
            cellspacing="0"
            class="tab"
          >
            <tbody>
              <tr>
                <td v-show="printModel.form.tableInput1" style="width:20%;">{{ printModel.form.tableInput1 }}</td>
                <td v-show="printModel.form.tableInput2" style="width:20%;">{{ printModel.form.tableInput2 }}</td>
                <td v-show="printModel.form.tableInput3" style="width:20%;">{{ printModel.form.tableInput3 }}</td>
                <td v-show="printModel.form.tableInput4" style="width:20%;">{{ printModel.form.tableInput4 }}</td>
                <td v-show="printModel.form.tableInput5" style="width:20%;">{{ printModel.form.tableInput5 }}</td>
              </tr>
              <tr v-for="(item, tableInputIndex) in printModel.tableInputCustomFieldAttr" :key="tableInputIndex + 1">
                <td v-show="item.tableInput1">{{ item.tableInput1 }}</td>
                <td v-show="item.tableInput2">{{ item.tableInput2 }}</td>
                <td v-show="item.tableInput3">{{ item.tableInput3 }}</td>
                <td v-show="item.tableInput4">{{ item.tableInput4 }}</td>
                <td v-show="item.tableInput5">{{ item.tableInput5 }}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <table style="width: 98%">
          <tbody>
          <tr v-show="printModel.form.GeneralSpecNativeHerbs">
            <td style="width: 25%">
              <b>植物主要成分</b>
            </td>
            <td style="width: 75%">
              {{ printModel.form.GeneralSpecNativeHerbs }}
            </td>
          </tr>
          <tr v-show="printModel.form.GeneralSpecAppearance">
                  <td style="width: 25%"><b>外观</b></td>
                  <td>
                    {{ printModel.form.GeneralSpecAppearance }}
                  </td>
                </tr>
          <tr v-show="printModel.form.GeneralSpecCarrier">
            <td style="width: 25%"><b>溶剂</b></td>
            <td style="width: 75%">{{ printModel.form.GeneralSpecCarrier }}</td>
          </tr>
          <tr v-show="printModel.form.GeneralSpecPreservative">
            <td style="width: 25%"><b>防腐剂</b></td>
            <td style="width: 75%">
              {{ printModel.form.GeneralSpecPreservative }}
            </td>
          </tr>
          <tr v-show="printModel.form.otherIngredients">
            <td style="width: 25%"><b>其他成分</b></td>
            <td style="width: 75%">
              {{ printModel.form.otherIngredients }}
            </td>
          </tr>
          <tr v-show="printModel.form.GeneralSpecCustomRowKey1">
            <td style="width: 25%"><b>{{ printModel.form.GeneralSpecCustomRowKey1 }}</b></td>
            <td style="width: 75%">
              {{
                printModel.form.GeneralSpecCustomRowValue1
              }}
            </td>
          </tr>
          <tr v-show="printModel.form.GeneralSpecCustomRowKey2">
            <td style="width: 25%"><b> {{ printModel.form.GeneralSpecCustomRowKey2 }}</b></td>
            <td style="width: 75%">
             {{
                printModel.form.GeneralSpecCustomRowValue2
              }}
            </td>
          </tr>
          <tr v-show="printModel.form.GeneralSpecCustomRowKey3">
            <td style="width: 25%"><b> {{ printModel.form.GeneralSpecCustomRowKey3 }}</b></td>
            <td style="width: 75%">
             {{
                printModel.form.GeneralSpecCustomRowValue3
              }}
            </td>
          </tr>
          </tbody>
              <tbody
                v-for="(item, genIndex) in printModel.genSpecCustomFieldAttr"
                :key="genIndex"
              >
                <tr v-show="item.customKey">
                  <td style="width: 30%">
                    <b>{{ item.customKey }}</b>
                  </td>
                  <td style="width: 70%">
                    <span t-field="o.apperance">{{ item.customValue }}</span>
                  </td>
                </tr>
              </tbody>
        </table>
        <!-- Analysis -->
        <div>
          <!-- <b><u>Analysis</u></b> -->
        </div>
        <div style="height: 20px"></div>
        <div style="font-size: 18px">
          <b><u>分析</u></b>
        </div>
        <div>
          <p></p>
        </div>
        <table style="width: 98%">
          <tbody>
          <tr>
            <td style="width: 25%"><b>检测项目</b></td>
            <td style="width: 25%"><b>标准</b></td>
            <td style="width: 25%"><b>结果</b></td>
            <td style="width: 25%"><b>测试方法</b></td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationBioactiveslevel ||
              printModel.form.ResultBioactiveslevel ||
              printModel.form.TestMethodBioactiveslevel
            "
          >
            <td style="width: 25%"><b>活性成分</b></td>
            <td style="width: 25%">
              ≥{{ printModel.form.SpecificationBioactiveslevel }}
            </td>
            <td style="width: 25%">
              {{ printModel.form.ResultBioactiveslevel }}
            </td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodBioactiveslevel }}
            </td>
          </tr>
          
          <tr
            v-show="
              printModel.form.SpecificationCustomRowKey1 ||
              printModel.form.ResultCustomRowKey1 ||
              printModel.form.TestMethodCustomRowKey1
            "
          >
            <td style="width: 25%"><b> {{ printModel.form.SpecificationCustomRowKey1 }}</b></td>
            <td style="width: 25%">
             {{
                printModel.form.SpecificationCustomRowValue1
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.ResultCustomRowValue1
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.TestMethodCustomRowValue1
              }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationCustomRowKey2 ||
              printModel.form.ResultCustomRowKey2 ||
              printModel.form.TestMethodCustomRowKey2
            "
          >
            <td style="width: 25%"><b>{{ printModel.form.SpecificationCustomRowKey2 }}</b></td>
            <td style="width: 25%">
              {{
                printModel.form.SpecificationCustomRowValue2
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.ResultCustomRowValue2
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.TestMethodCustomRowValue2
              }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationCustomRowKey3 ||
              printModel.form.ResultCustomRowKey3 ||
              printModel.form.TestMethodCustomRowKey3
            "
          >
            <td style="width: 25%"><b>{{ printModel.form.SpecificationCustomRowKey3 }}</b></td>
            <td style="width: 25%">
              {{
                printModel.form.SpecificationCustomRowValue3
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.ResultCustomRowValue3
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.TestMethodCustomRowValue3
              }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationCustomRowKey4 ||
              printModel.form.ResultCustomRowKey4 ||
              printModel.form.TestMethodCustomRowKey4
            "
          >
            <td style="width: 25%"><b>{{ printModel.form.SpecificationCustomRowKey4 }}</b></td>
            <td style="width: 25%">
              {{
                printModel.form.SpecificationCustomRowValue4
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.ResultCustomRowValue4
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.TestMethodCustomRowValue4
              }}
            </td>
          </tr>
          </tbody>
          
          <tbody
            v-for="(
              item, analysisIndex
            ) in printModel.analysisCustomFieldAttr"
            :key="analysisIndex"
          >
            <tr v-show="item.customKey">
              <td style="width: 25%">
                <b>{{ item.customKey }}</b>
              </td>
              <td style="width: 25%">
                {{ item.customValue }}
              </td>
              <td style="width: 25%">
                {{ item.customValue2 }}
              </td>
              <td style="width: 25%">
                {{ item.customValue1 }}
              </td>
            </tr>
          </tbody>
          <tbody>
          <tr
            v-show="
              printModel.form.SpecificationpH ||
              printModel.form.ResultpH  
            "
          >
            <td style="width: 25%"><b>pH</b></td>
            <td style="width: 25%">{{ printModel.form.SpecificationpH }}</td>
            <td style="width: 25%">{{ printModel.form.ResultpH }}</td>
            <td style="width: 25%">{{ printModel.form.TestMethodpH }}</td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationHeavyMetal ||
              printModel.form.ResultHeavyMetal  
            "
          >
            <td style="width: 25%"><b>重金属</b></td>
            <td style="width: 25%">
              {{ printModel.form.SpecificationHeavyMetal }}
            </td>
            <td style="width: 25%">
              {{ printModel.form.ResultHeavyMetal }} {{checkNumber(printModel.form.ResultHeavyMetal)?'ppm':''}}
              </td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodHeavyMetal }}
            </td>
          </tr>
          
          <tr
            v-show="
              printModel.form.SpecificationArsenic ||
              printModel.form.ResultArsenic 
            "
          >
            <td style="width: 25%"><b>砷</b></td>
            <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationArsenic }} ppm
            </td>
            <td style="width: 25%">{{ printModel.form.ResultArsenic }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodArsenic }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationCadmium ||
              printModel.form.ResultCadmium 
            "
          >
            <td style="width: 25%"><b>镉</b></td>
            <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationCadmium }} ppm
            </td>
            <td style="width: 25%">{{ printModel.form.ResultCadmium }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodCadmium }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationLead ||
              printModel.form.ResultLead 
            "
          >
            <td style="width: 25%"><b>铅</b></td>
            <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationLead }} ppm
            </td>
            <td style="width: 25%">{{ printModel.form.ResultLead }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodLead }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationMercury ||
              printModel.form.ResultMercury 
            "
          >
            <td style="width: 25%"><b>汞</b></td>
            <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationMercury }} ppm
            </td>
            <td style="width: 25%">{{ printModel.form.ResultMercury }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodMercury }}
            </td>
          </tr>

          <tr
            v-show="
              printModel.form.SpecificationPesticides ||
              printModel.form.ResultPesticides  
            "
          >
            <td style="width: 25%"><b>农药残留</b></td>
            <td style="width: 25%">
              {{ printModel.form.SpecificationPesticides }}
            </td>
            <td style="width: 25%">{{ printModel.form.ResultPesticides }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodPesticides }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationTotalPlateCount ||
              printModel.form.ResultTotalPlateCount  
            "
          >
            <td style="width: 25%"><b>细菌总数</b></td>
            <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationTotalPlateCount }} cfu/g
            </td>
            <td style="width: 25%">
              {{ printModel.form.ResultTotalPlateCount }} {{checkNumber(printModel.form.ResultTotalPlateCount)?'cfu/g':''}}
            </td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodTotalPlateCount }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationYeastandMold ||
              printModel.form.ResultYeastandMold  
            "
          >
            <td style="width: 25%"><b>酵母和霉菌</b></td>
            <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationYeastandMold }} cfu/g
            </td>
            <td style="width: 25%">
              {{ printModel.form.ResultYeastandMold }} {{checkNumber(printModel.form.ResultYeastandMold)?'cfu/g':''}}
            </td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodYeastandMold }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationEColi ||
              printModel.form.ResultEColi  
            "
          >
            <td style="width: 25%"><b>大肠杆菌</b></td>
            <td style="width: 25%">{{ printModel.form.SpecificationEColi }}</td>
            <td style="width: 25%">{{ printModel.form.ResultEColi }}</td>
            <td style="width: 25%">{{ printModel.form.TestMethodEColi }}</td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationSalmonella ||
              printModel.form.ResultSalmonella  
            "
          >
            <td style="width: 25%"><b>沙门氏菌</b></td>
            <td style="width: 25%">
              {{ printModel.form.SpecificationSalmonella }}
            </td>
            <td style="width: 25%">{{ printModel.form.ResultSalmonella }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodSalmonella }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationStaphAureus ||
              printModel.form.ResultStaphAureus  
            "
          >
            <td style="width: 25%"><b>金色葡萄球菌</b></td>
            <td style="width: 25%">
              {{ printModel.form.SpecificationStaphAureus }}
            </td>
            <td style="width: 25%">{{ printModel.form.ResultStaphAureus }}</td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodStaphAureus }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationTotalColiform ||
              printModel.form.ResultTotalColiform  
            "
          >
            <td style="width: 25%"><b>大肠菌群</b></td>
            <!-- <td style="width: 25%">
              &lt;{{ printModel.form.SpecificationTotalColiform }} MPN/g
            </td> -->
            <td style="width: 25%" v-if="
            !printModel.form.SpecificationTotalColiform || 
            printModel.form.SpecificationTotalColiform.toLowerCase()=='negative' || 
            printModel.form.SpecificationTotalColiform.toLowerCase()=='阴性'">
              {{ printModel.form.SpecificationTotalColiform }}
            </td>
            <td style="width: 25%" v-else>
              &lt;{{ printModel.form.SpecificationTotalColiform }} MPN/g
            </td>
            <td style="width: 25%">
              {{ printModel.form.ResultTotalColiform }}
            </td>
            <td style="width: 25%">
              {{ printModel.form.TestMethodTotalColiform }}
            </td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationColor ||
              printModel.form.ResultColor  
            "
          >
            <td style="width: 25%"><b>颜色</b></td>
            <td style="width: 25%">{{ printModel.form.SpecificationColor }}</td>
            <td style="width: 25%">{{ printModel.form.ResultColor }}</td>
            <td style="width: 25%">{{ printModel.form.TestMethodColor }}</td>
          </tr>
          <tr
            v-show="
              printModel.form.SpecificationOdor ||
              printModel.form.ResultOdor  
            "
          >
            <td style="width: 25%"><b>气味</b></td>
            <td style="width: 25%">{{ printModel.form.SpecificationOdor }}</td>
            <td style="width: 25%">{{ printModel.form.ResultOdor }}</td>
            <td style="width: 25%">{{ printModel.form.TestMethodOdor }}</td>
          </tr>
          <!-- <tr
            v-show="
              printModel.form.SpecificationTaste ||
              printModel.form.ResultTaste  
            "
          >
            <td style="width: 25%"><b>味道</b></td>
            <td style="width: 25%">{{ printModel.form.SpecificationTaste }}</td>
            <td style="width: 25%">{{ printModel.form.ResultTaste }}</td>
            <td style="width: 25%">{{ printModel.form.TestMethodTaste }}</td>
          </tr> -->
          <tr
            v-show="
              printModel.form.SpecificationCustomRowKey5 ||
              printModel.form.ResultCustomRowKey5 ||
              printModel.form.TestMethodCustomRowKey5
            "
          >
            <td style="width: 25%"><b>{{ printModel.form.SpecificationCustomRowKey5 }}</b></td>
            <td style="width: 25%">
              {{
                printModel.form.SpecificationCustomRowValue5
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.ResultCustomRowValue5
              }}
            </td>
            <td style="width: 25%"> {{
                printModel.form.TestMethodCustomRowValue5
              }}
            </td>
          </tr>
          </tbody>
          <tbody
            v-for="(
              item, analysisIndex1
            ) in printModel.analysisCustomFieldAttr1"
            :key="analysisIndex1"
          >
            <tr v-show="item.customKey">
              <td style="width: 25%">
                <b>{{ item.customKey }}</b>
              </td>
              <td style="width: 25%">
                {{ item.customValue }}
              </td>
              <td style="width: 25%">
                {{ item.customValue2 }}
              </td>
              <td style="width: 25%">
                {{ item.customValue1 }}
              </td>
            </tr>
          </tbody>
        </table>
       
        <div style="clear: both"></div>
        <div style="height: 20px"></div>
        <div style="font-size: 18px">
          <b><u>注释</u></b>
        </div>

        <div
          class="footer"
          id="footer"
          style="
            font-size: 11px;
            font-family: Times New Roman;
            margin-top: 10px;
          "
        >
          <div>
            <span
              ><i
                >* 不同批次产品的颜色可能会因天然原材料的自然变化而产生差异。</i
              ></span
            >
          </div>
          <div style="height: 10px"></div>
          <div>
            <span
              ><i
                >* 产品含抗氧化化合物，可能会随着时间推移颜色变深但不影响使用效果。</i
              ></span
            >
          </div>
          <div style="height: 10px"></div>
          <div>
            <span
              ><i
                >* 天然植物产品在长期静置时可能会产生一些产品本身的沉淀物，这不会影响产品的质量；如发现产品有沉淀，请在使用前适当加热并搅拌至充分混合。</i
              ></span
            >
          </div>
          <div style="height: 10px"></div>
          <div>
            <span
              ><i
                >* 如果产品中含水量低于50%，则产品的pH 值必须在1%产品的水溶液中测定。</i
              ></span
            >
          </div>
          <p v-for="(item, index) in printModel.newNoteArr" :key="index">
            * {{item.content}}
          </p>
        </div>

        <div style="height: 10px"></div>
        <div>
          <div style="float: left;">
            质量保证员- <span style="font-size:28px;font-family: 'Comic Sans MS', cursive;">{{ printModel.formData.updateName }}</span>
          </div>
          <div style="float: right">日期: {{ formatDate(printModel.formData.createTime) }}</div>
        </div>
          <div style="height: 20px;clear:both;"></div>
          <div style="font-size: 14px;">
            <b><u>Disclaimer: The product specifications, limits, test methods, and information contained on this document are accurate to the best of our knowledge based upon general industry information, available scientific data, and customer requests. These values are not intended to be used as specifications for a finished product and should be used only at the sole discretion of the purchaser. According to GMP regulations, the test results of the product must be independently verified by the purchasing party. The appropriate use of this product is the sole responsibility of the user or the purchasing party.</u></b>
          </div>

          <div style="height: 10px"></div>
          <div style="text-align: center">
            <b
              ><u>
                539 Parrott Street San Jose CA, 95112 Tel: 408-287-7871
                Fax:408-287-8838</u
              ></b
            >
          </div>
        <div style="height: 20px"></div>
        <div>
        </div>
        <FooterSigner></FooterSigner>
      </div>
    </div>
  </div>
</template>
<script>
import FooterSigner from "./FooterSigner";
import base from "@/common/base.js";
export default {
  name: "CoaLiquid",
  mixins: [base],
  components: { FooterSigner },
  props: ["printModel"],
  data() {
    return {
      manufacturingDate: "",
      expirationDate: "",
      loginName: localStorage.getItem("loginUserNameKey"),
    };
  },
  computed: {
    maxArr() {
      let tmp = [
        this.printModel.inclNameArr.length,
        this.printModel.commonNameArr.length,
        this.printModel.botanicalNameArr.length,
        //this.printModel.nativeHerbsArr.length,
        this.printModel.partUsedArr.length,
      ].sort();
      return tmp[tmp.length - 1];
    },
    isShowTable(){
      if(this.printModel.form.tableInput1 || this.printModel.form.tableInput2 || this.printModel.form.tableInput3 || this.printModel.form.tableInput4 || this.printModel.form.tableInput5){
        return true
      }
      return false
    }
  },
  methods: {
    isSingle(){
      var count = 0;
      var name = "";
      var arr = [];
      if(this.printModel.commonNameArr.length>=1){
          name="Common Name";
          count = count+1;
          arr = this.printModel.commonNameArr;
      }
      if(this.printModel.inclNameArr.length>=1){
          name="INCI name";
          count = count+1;
          arr = this.printModel.inclNameArr;
      }
      if(this.printModel.botanicalNameArr.length>=1){
          name="Botanical Name";
          count = count+1;
          arr = this.printModel.botanicalNameArr;
      }
      if(this.printModel.partUsedArr.length>=1){
          name="Part Used";
          count = count+1;
          arr = this.printModel.partUsedArr;
      }
      let res =  {count,name,arr};
      return res
    },
    formatTime(time,format){
      return base.methods.formatTime(time,format);
    },
    formatDate(time){
      return base.methods.formatDate({ date: time });
    },
    checkNumber(number){
      let firstStr=(number + "").substring(0,1)
      if(firstStr=='<' || firstStr=='≤'){
        number = number.substring(1)
      }
      var numReg = /^[0-9]+([.]{1}[0-9]+){0,1}$/
      var numRe = new RegExp(numReg)
      if (!numRe.test(number)) {
        return false
      }
      return true
    }
  },
  mounted() {
    console.log("====printModel====");
    console.log(this.printModel);
  },
};
</script>

<style scoped>
.tab tr td,
.tab thead th {
  padding: 5px;
}
</style>